import { AxiosResponse } from 'axios';
import apiClient from '../../../../shared/infrastructure/api/client';
import { ChatHistoryResponse, ChatMessage } from '../../domain/PatientChat';
import { CouplePatientChatRequest, CouplePatientChatResponse } from '../../domain/CouplePatientChat';

/** The Memoria aumentada assistant for a group, and the conversation it keeps. */
export const GroupPatientChatApiService = {
  sendMessage: (
    groupPatientId: string,
    payload: CouplePatientChatRequest,
  ): Promise<AxiosResponse<CouplePatientChatResponse>> =>
    apiClient.post(`/group-patients/${groupPatientId}/chat`, payload),

  loadHistory: async (groupPatientId: string): Promise<ChatMessage[]> => {
    const res = await apiClient.get<ChatHistoryResponse>(`/group-patients/${groupPatientId}/chat-history`);
    return res.data.messages;
  },

  saveHistory: async (groupPatientId: string, messages: ChatMessage[]): Promise<void> => {
    await apiClient.put(`/group-patients/${groupPatientId}/chat-history`, { messages });
  },
};
